import { render, staticRenderFns } from "./MorbidityReport.vue?vue&type=template&id=9bae0e1c&scoped=true"
import script from "./MorbidityReport.vue?vue&type=script&lang=js"
export * from "./MorbidityReport.vue?vue&type=script&lang=js"
import style0 from "./MorbidityReport.vue?vue&type=style&index=0&id=9bae0e1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bae0e1c",
  null
  
)

export default component.exports